/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const featureId = feature.getID();
    const SCREENS = feature.getSettingValue('SCREENS');
    const BACKCOLOR = feature.getSettingValue('BACKCOLOR');
    const FORECOLOR = feature.getSettingValue('FORECOLOR');
    const IMAGES = feature.getSettingValue('IMAGES');


    const backgroundColors = [];

    let screensTemplate = '';
    for (let i = 0; i < SCREENS.length; i++) {
        const screen = SCREENS[i];
        const widgets = screen.getSettingValue('WIDGETS');
        backgroundColors.push(screen.getSettingValue('BACKCOLOR'));
        if (widgets.length === 0) {
            continue;
        }
        const screenBlocks = screen.getCodeBlocks();
        blocks.push(...screenBlocks);
        const screenId = screen.getID();
        screensTemplate += ` {
            ID: "${screenId}",
            BACKCOLOR: "${backgroundColors[i]}",
        },
        `;

        blocks.push({
            location: 'display_widgets',
            blockType: BlockType.CODE,
            template: `
if (screenIndex === ${i}) {
    /****display_widgets_${i}****/
}
            `,
        });
    }

    let imagesTemplate = '';
    for (let i = 0; i < IMAGES.length; i++) {
        const image = IMAGES[i];
        const imageId = image.getID();
        const NAME = image.getSettingValue('NAME');
        const IMG = image.getSettingValue('IMG');
        const WIDTH = image.getSettingValue('WIDTH');
        const HEIGHT = image.getSettingValue('HEIGHT');
        imagesTemplate += `
${imageId}: {
    NAME: "${NAME}",
    IMG: "${IMG.split('\n')[1]}",
    WIDTH: ${WIDTH},
    HEIGHT: ${HEIGHT},
},
        `;
    }

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    currentScreenIndex: 0,
    BACKCOLOR: "${backgroundColors[0]}",
    FORECOLOR: "${FORECOLOR}",
    IMAGES: {
        ${imagesTemplate}
    },
    SCREENS: [
        ${screensTemplate}
    ],
})
`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function draw_text(element, VISIBLE, TEXT, X, Y, COLOR, ) {
    const {
        ID,
        W,
        H,
        BACKGROUND_COLOR,
        FONT,
        TEXT_ALIGNMENT,
        SCREEN_INDEX,
    } = element;
    simulator.updateContext(ID, {
        TEXT: TEXT || element.TEXT,
        X: X || element.X,
        Y: Y || element.Y,
        COLOR: COLOR || element.COLOR,
        BACKGROUND_COLOR,
        FONT,
        TEXT_ALIGNMENT,
        VISIBLE: VISIBLE || element.VISIBLE,
        SCREEN_INDEX,
    })
}
        `,
    });

    return blocks;
};
